/**
 * ============================================================================
 * RatingDistribution - Rating Breakdown Chart
 * ============================================================================
 */

import React from 'react';
import { Star } from 'lucide-react';
import type { ReviewStats } from '../../types/reviews';

interface RatingDistributionProps {
  stats: ReviewStats;
}

export function RatingDistribution({ stats }: RatingDistributionProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Rating Distribution</h3>
      <div className="space-y-3">
        {stats.rating_distribution.map((dist) => (
          <div key={dist.rating} className="flex items-center gap-4">
            <div className="flex items-center gap-1.5 w-16">
              <span className="text-sm font-medium text-gray-700">{dist.rating}</span>
              <Star className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" />
            </div>
            <div className="flex-1">
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-yellow-400 h-2 rounded-full transition-all"
                  style={{ width: `${dist.percentage}%` }}
                />
              </div>
            </div>
            <div className="w-24 text-right">
              <span className="text-sm text-gray-600">
                {dist.count} ({dist.percentage}%)
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
